import { useEffect, useMemo, useState } from "react";
import api from "@/lib/api";

const EMPTY = {
  id: null,
  data: "",
  esecutore: "",
  esecutore_incaricato_id: "",
  trattamenti_codici: [],
  annotazioni: "",
  anomalie: "",
};

export default function PrivacyControlliPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);
  const [editing, setEditing] = useState(null);
  const [esecutoriPick, setEsecutoriPick] = useState([]);
  const [trattamentiPick, setTrattamentiPick] = useState([]);
  const [trattPickerOpen, setTrattPickerOpen] = useState(false);
  const [trattPickerQ, setTrattPickerQ] = useState("");

  const load = async () => {
    setLoading(true); setErr(null);
    try {
      const r = await api.get("/privacy/controlli");
      setItems(r.data?.items || []);
    } catch (e) {
      setErr(e.response?.data?.detail || "Errore caricamento");
    } finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const loadLookups = async () => {
    try {
      const [re, rt] = await Promise.all([
        api.get("/privacy/controlli/_lookups/esecutori"),
        api.get("/privacy/controlli/_lookups/trattamenti"),
      ]);
      setEsecutoriPick(re.data?.items || []);
      setTrattamentiPick(rt.data?.items || []);
    } catch { /* ignore */ }
  };

  const openNew = async () => {
    await loadLookups();
    setEditing({ ...EMPTY, data: new Date().toISOString().slice(0, 10) });
  };
  const openEdit = async (it) => {
    await loadLookups();
    setEditing({ ...EMPTY, ...it });
  };

  const save = async () => {
    if (!editing.data) { alert("Data obbligatoria"); return; }
    if (!editing.esecutore?.trim()) { alert("Esecutore obbligatorio"); return; }
    try {
      const body = {
        data: editing.data,
        esecutore: editing.esecutore,
        esecutore_incaricato_id: editing.esecutore_incaricato_id || null,
        trattamenti_codici: editing.trattamenti_codici || [],
        annotazioni: editing.annotazioni || "",
        anomalie: editing.anomalie || "",
      };
      if (editing.id) {
        await api.put(`/privacy/controlli/${editing.id}`, body);
      } else {
        await api.post("/privacy/controlli", body);
      }
      setEditing(null);
      await load();
    } catch (e) {
      alert("Errore: " + (e.response?.data?.detail || e.message));
    }
  };

  const remove = async (it) => {
    if (!window.confirm(`Eliminare il controllo del ${fmtData(it.data)}?`)) return;
    try {
      await api.delete(`/privacy/controlli/${it.id}`);
      await load();
    } catch (e) {
      alert("Errore: " + (e.response?.data?.detail || e.message));
    }
  };

  return (
    <div data-testid="privacy-controlli-page" style={{ padding: "12px 20px" }}>
      <div style={{ display: "flex", alignItems: "center", marginBottom: 14 }}>
        <h1 style={{ margin: 0, fontSize: 18, color: "#0d47a1" }}>🔍 Archivio Controlli Privacy</h1>
        <button data-testid="ctrl-new-btn" onClick={openNew}
          style={{ marginLeft: "auto", padding: "7px 18px", background: "#0d47a1", color: "white", border: "none", borderRadius: 3, fontSize: 12, fontWeight: 700, cursor: "pointer" }}>
          ➕ Nuovo Controllo
        </button>
      </div>

      {err && <div style={{ padding: 8, background: "#ffebee", color: "#c62828", border: "1px solid #ef9a9a", marginBottom: 8, fontSize: 12 }}>{err}</div>}
      {loading && <div style={{ padding: 12, fontSize: 12, color: "#666" }}>Caricamento…</div>}

      <div style={{ overflowX: "auto", border: "1px solid #ddd" }}>
        <table className="sw-table" style={{ width: "100%", fontSize: 12, borderCollapse: "collapse" }}>
          <thead className="thead-blue">
            <tr>
              <th style={th}>DATA</th>
              <th style={th}>ESECUTORE</th>
              <th style={th}>ARCHIVI VISIONATI</th>
              <th style={th}>ANNOTAZIONI</th>
              <th style={th}>ANOMALIE</th>
              <th style={{ ...th, width: 160, textAlign: "center" }}>AZIONI</th>
            </tr>
          </thead>
          <tbody>
            {!loading && items.length === 0 && (
              <tr><td colSpan={6} style={{ padding: 20, textAlign: "center", color: "#999" }}>Nessun controllo registrato</td></tr>
            )}
            {items.map(it => (
              <tr key={it.id} style={{ borderBottom: "1px solid #eee", background: it.anomalie ? "#fff8e1" : "white" }}>
                <td style={{ ...td, fontWeight: 700, whiteSpace: "nowrap" }}>{fmtData(it.data)}</td>
                <td style={td}>{it.esecutore}</td>
                <td style={td}>
                  {(it.trattamenti_labels || []).length === 0 && <span style={{ color: "#bbb" }}>—</span>}
                  {(it.trattamenti_labels || []).map((t, i) => (
                    <span key={i} style={{
                      display: "inline-block", padding: "2px 8px", margin: "2px 4px 2px 0",
                      background: "#e3f2fd", color: "#0d47a1", borderRadius: 3, fontSize: 10, fontWeight: 600,
                    }}>
                      <b>{t.codice}</b>{t.nome ? ` · ${t.nome}` : ""}
                    </span>
                  ))}
                </td>
                <td style={{ ...td, fontSize: 11, color: "#555", maxWidth: 300, whiteSpace: "pre-wrap" }}>{it.annotazioni || "—"}</td>
                <td style={{ ...td, fontSize: 11, color: it.anomalie ? "#b71c1c" : "#999", maxWidth: 300, whiteSpace: "pre-wrap", fontWeight: it.anomalie ? 700 : 400 }}>
                  {it.anomalie || "—"}
                </td>
                <td style={{ ...td, textAlign: "center", whiteSpace: "nowrap" }}>
                  <button data-testid={`ctrl-edit-${it.id}`} onClick={() => openEdit(it)} style={btnBlue}>✏ Modifica</button>
                  <button data-testid={`ctrl-del-${it.id}`} onClick={() => remove(it)} style={btnRed}>🗑</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {editing && (
        <ControlloEditModal
          ctrl={editing}
          setCtrl={setEditing}
          onClose={() => setEditing(null)}
          onSave={save}
          esecutoriPick={esecutoriPick}
          trattamentiPick={trattamentiPick}
          trattPickerOpen={trattPickerOpen}
          setTrattPickerOpen={setTrattPickerOpen}
          trattPickerQ={trattPickerQ}
          setTrattPickerQ={setTrattPickerQ}
        />
      )}
    </div>
  );
}

function ControlloEditModal({ ctrl, setCtrl, onClose, onSave, esecutoriPick, trattamentiPick, trattPickerOpen, setTrattPickerOpen, trattPickerQ, setTrattPickerQ }) {
  const setField = (k, v) => setCtrl(prev => ({ ...prev, [k]: v }));
  const setEsecutoreFromIncaricato = (id) => {
    if (!id) {
      setCtrl(prev => ({ ...prev, esecutore_incaricato_id: "" }));
      return;
    }
    const e = esecutoriPick.find(x => x.id === id);
    setCtrl(prev => ({ ...prev, esecutore_incaricato_id: id, esecutore: e ? e.etichetta : prev.esecutore }));
  };
  const addTrattamento = (codice) => {
    setCtrl(prev => {
      if ((prev.trattamenti_codici || []).includes(codice)) return prev;
      return { ...prev, trattamenti_codici: [...(prev.trattamenti_codici || []), codice] };
    });
  };
  const removeTrattamento = (codice) => {
    setCtrl(prev => ({ ...prev, trattamenti_codici: (prev.trattamenti_codici || []).filter(c => c !== codice) }));
  };

  const trattMap = useMemo(() => {
    const m = {};
    for (const t of trattamentiPick) m[t.codice] = t;
    return m;
  }, [trattamentiPick]);

  const filteredTratt = useMemo(() => {
    const qn = (trattPickerQ || "").toLowerCase().trim();
    const sel = new Set(ctrl.trattamenti_codici || []);
    const all = trattamentiPick.filter(t => !sel.has(t.codice));
    if (!qn) return all.slice(0, 200);
    return all.filter(t => `${t.codice} ${t.nome || ""} ${t.descrizione || ""}`.toLowerCase().includes(qn)).slice(0, 200);
  }, [trattPickerQ, trattamentiPick, ctrl.trattamenti_codici]);

  return (
    <div onClick={onClose} style={{
      position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 1000,
      display: "flex", alignItems: "center", justifyContent: "center", padding: 20,
    }}>
      <div onClick={e => e.stopPropagation()} style={{
        background: "white", borderRadius: 6, padding: 20, width: "100%", maxWidth: 920,
        maxHeight: "92vh", overflowY: "auto", boxShadow: "0 12px 32px rgba(0,0,0,0.3)",
      }}>
        <h2 style={{ margin: "0 0 14px 0", color: "#0d47a1", fontSize: 16 }}>
          {ctrl.id ? "✏ Modifica Controllo" : "➕ Nuovo Controllo"}
        </h2>

        <div style={{ display: "grid", gridTemplateColumns: "180px 1fr 1fr", gap: 10, marginBottom: 12 }}>
          <Field label="DATA *">
            <input data-testid="ctrl-data" type="date" value={ctrl.data || ""} onChange={e => setField("data", e.target.value)} style={inputStyle} />
          </Field>
          <Field label="ESECUTORE PROPOSTO (Incaricati ruolo controllore)">
            <select data-testid="ctrl-esecutore-pick" value={ctrl.esecutore_incaricato_id || ""}
              onChange={e => setEsecutoreFromIncaricato(e.target.value)} style={inputStyle}>
              <option value="">— Scegli dall'archivio o scrivi a mano →</option>
              {esecutoriPick.map(e => (
                <option key={e.id} value={e.id}>{e.etichetta}</option>
              ))}
            </select>
          </Field>
          <Field label="ESECUTORE (nome modificabile) *">
            <input data-testid="ctrl-esecutore" value={ctrl.esecutore || ""}
              onChange={e => setField("esecutore", e.target.value)} placeholder="Nome cognome…" style={inputStyle} />
          </Field>
        </div>

        {/* Archivi visionati */}
        <Section title="ARCHIVI VISIONATI (Trattamenti collegati)">
          <div style={{ marginBottom: 8 }}>
            {(ctrl.trattamenti_codici || []).length === 0 && (
              <div style={{ color: "#999", fontSize: 12, padding: 8 }}>Nessun trattamento collegato</div>
            )}
            {(ctrl.trattamenti_codici || []).map(codice => {
              const t = trattMap[codice] || { codice, nome: "" };
              return (
                <span key={codice} style={{
                  display: "inline-flex", alignItems: "center", gap: 6,
                  padding: "5px 10px", margin: "3px 4px 3px 0",
                  background: "#e3f2fd", color: "#0d47a1", borderRadius: 4,
                  fontSize: 11, fontWeight: 600,
                }}>
                  <b>{t.codice}</b>{t.nome ? ` · ${t.nome}` : ""}
                  <button data-testid={`ctrl-trat-rm-${codice}`} onClick={() => removeTrattamento(codice)}
                    style={{ background: "transparent", color: "#c62828", border: "none", cursor: "pointer", fontSize: 14, padding: 0, lineHeight: 1 }}>×</button>
                </span>
              );
            })}
          </div>
          <button data-testid="ctrl-add-trat" onClick={() => setTrattPickerOpen(true)}
            style={{ padding: "5px 12px", background: "#0d47a1", color: "white", border: "none", borderRadius: 3, fontSize: 11, fontWeight: 700, cursor: "pointer" }}>
            📚 Collega Trattamenti
          </button>
        </Section>

        <Section title="ANNOTAZIONI">
          <textarea data-testid="ctrl-annotazioni" value={ctrl.annotazioni || ""}
            onChange={e => setField("annotazioni", e.target.value)} rows={3}
            placeholder="Note sul controllo, attività svolte, riscontri positivi…"
            style={{ ...inputStyle, resize: "vertical" }} />
        </Section>

        <Section title="ANOMALIE RISCONTRATE">
          <textarea data-testid="ctrl-anomalie" value={ctrl.anomalie || ""}
            onChange={e => setField("anomalie", e.target.value)} rows={3}
            placeholder="Eventuali anomalie, non conformità, azioni correttive…"
            style={{ ...inputStyle, resize: "vertical", background: ctrl.anomalie ? "#fff8e1" : "white" }} />
        </Section>

        <div style={{ marginTop: 16, display: "flex", gap: 8, justifyContent: "flex-end" }}>
          <button data-testid="ctrl-cancel" onClick={onClose}
            style={{ padding: "7px 14px", background: "#eee", color: "#333", border: "1px solid #ccc", borderRadius: 3, fontSize: 12, cursor: "pointer" }}>
            Annulla
          </button>
          <button data-testid="ctrl-save" onClick={onSave}
            style={{ padding: "7px 20px", background: "#0d47a1", color: "white", border: "none", borderRadius: 3, fontSize: 12, fontWeight: 700, cursor: "pointer" }}>
            💾 Salva
          </button>
        </div>

        {/* Trattamenti picker */}
        {trattPickerOpen && (
          <div onClick={() => setTrattPickerOpen(false)} style={{
            position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 1100,
            display: "flex", alignItems: "center", justifyContent: "center", padding: 20,
          }}>
            <div onClick={e => e.stopPropagation()} style={{
              background: "white", borderRadius: 6, padding: 16, width: "100%", maxWidth: 620,
              maxHeight: "80vh", overflowY: "auto",
            }}>
              <h3 style={{ margin: "0 0 10px 0", color: "#0d47a1", fontSize: 14 }}>📚 Scegli un trattamento</h3>
              <input data-testid="ctrl-trat-search" autoFocus value={trattPickerQ}
                onChange={e => setTrattPickerQ(e.target.value)}
                placeholder="Cerca codice, nome, descrizione…"
                style={{ ...inputStyle, marginBottom: 10 }} />
              <div style={{ maxHeight: 400, overflowY: "auto", border: "1px solid #ddd" }}>
                {filteredTratt.length === 0 && (
                  <div style={{ padding: 20, textAlign: "center", color: "#999", fontSize: 12 }}>Nessun risultato</div>
                )}
                {filteredTratt.map(t => (
                  <button key={t.codice} data-testid={`ctrl-trat-pick-${t.codice}`}
                    onClick={() => { addTrattamento(t.codice); setTrattPickerQ(""); }}
                    style={{
                      display: "block", width: "100%", textAlign: "left",
                      padding: "6px 10px", border: "none", background: "white", cursor: "pointer",
                      fontSize: 12, borderBottom: "1px solid #f0f0f0",
                    }}>
                    <b style={{ fontFamily: "Consolas", color: "#0d47a1" }}>{t.codice}</b>
                    <span style={{ marginLeft: 8 }}>{t.nome}</span>
                    {t.descrizione && <div style={{ color: "#888", fontSize: 10, marginTop: 2 }}>{t.descrizione}</div>}
                  </button>
                ))}
              </div>
              <div style={{ marginTop: 10, textAlign: "right" }}>
                <button onClick={() => setTrattPickerOpen(false)}
                  style={{ padding: "5px 12px", background: "#eee", border: "1px solid #ccc", borderRadius: 3, fontSize: 11, cursor: "pointer" }}>
                  Chiudi
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div style={{ marginTop: 14, padding: 12, background: "#fafafa", border: "1px solid #e0e0e0" }}>
      <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: 0.5, color: "#0d47a1", marginBottom: 8 }}>{title}</div>
      {children}
    </div>
  );
}

function Field({ label, children }) {
  return (
    <div>
      <div style={{ fontSize: 10, fontWeight: 700, color: "#555", marginBottom: 3, letterSpacing: 0.5 }}>{label}</div>
      {children}
    </div>
  );
}

function fmtData(s) {
  if (!s) return "—";
  try {
    const [y, m, d] = s.split("-");
    if (y && m && d) return `${d}/${m}/${y}`;
  } catch { /* noop */ }
  return s;
}

const th = { padding: "4px 6px", textAlign: "left", fontSize: 11, fontWeight: 700, letterSpacing: 0.5 };
const td = { padding: "6px 10px", verticalAlign: "top", textAlign: "left" };
const inputStyle = { padding: "5px 8px", border: "1px solid #ccc", fontSize: 12, width: "100%", boxSizing: "border-box" };
const btnBlue = { padding: "4px 10px", marginRight: 4, background: "#1565c0", color: "white", border: "none", borderRadius: 3, fontSize: 11, fontWeight: 700, cursor: "pointer" };
const btnRed = { padding: "4px 8px", background: "#c62828", color: "white", border: "none", borderRadius: 3, fontSize: 11, fontWeight: 700, cursor: "pointer" };
